import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { UserService } from 'src/app/core/common-services/user.services';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { NotificationDataService } from 'src/app/core/data-services/notification/notification-data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { ChangePasswordComponent } from 'src/app/features/profile/change-password/change-password.component';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnDestroy {
  companyName: string = '';
  @ViewChild('logoutTemplateRef') logoutTemplateRef!: TemplateRef<any>;
  logoUrl:string='';
  isMediumOrAbove: boolean = false;
  mobileSidebarOpen: boolean = false;
  private breakpointSubscription?: Subscription;
  constructor(
    public languageService: LanguageService,
    public userService: UserService,
    public notificationService: NotificationService,
    private notificationDataService:NotificationDataService,
    private userDataService: UserDataService,
    private matDialog:MatDialog,
    private tenantConfigService: TenantConfigService,
    private breakpointObserver: BreakpointObserver,
    private dialogService: DialogService,
  ) {
    this.companyName = localStorage.getItem('currentLang') === 'ar' && this.tenantConfigService.tenant.companyNameAr ? this.tenantConfigService.tenant.companyNameAr : this.tenantConfigService.tenant.companyName;
    this.logoUrl=this.tenantConfigService.tenant.coloredLogoUrl;
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(min-width: 768px)'])
      .subscribe(result => {
        this.isMediumOrAbove = result.matches;
        if (this.isMediumOrAbove) {
          this.mobileSidebarOpen = false;
        }
      });
  }

  getPushNotificationsCount(){
    this.notificationDataService.GetUnreadNotificationsCount().subscribe({
      next:(res)=>{
        if(res&&res.data){
          this.notificationService.unreadPushNotificationsCount=res.data.unreadNotificationsCount;
        }
      }
    })
  }
  logOut() {
    this.closeLogoutDialog();
    return this.userDataService.Logout().subscribe({
      next: () => {
        this.userService.logout();
      },
      error: (err) => {
        console.error('Error occurred during logout:', err);
        this.userService.logout(); // Call in error case as well
      }
    });
  }
  closeLogoutDialog(){
    this.matDialog.closeAll();
  }
  openLogoutDialog(){
    this.closeLogoutDialog();
    this.matDialog.open(this.logoutTemplateRef, {     
      height: 'auto',
      width:'600px',
      panelClass:'dialog-class',
    });
  }
  get isSidebarOpen(): boolean {
    return this.isMediumOrAbove || this.mobileSidebarOpen;
  }
  toggleSidebar(): void {
    this.mobileSidebarOpen = !this.mobileSidebarOpen;
  }
  closeSidebar(): void {
    if (!this.isMediumOrAbove) {
      this.mobileSidebarOpen = false;
    }
  }
  ngOnDestroy(): void {
    this.breakpointSubscription?.unsubscribe();
  }
  openChangePasswordDialog(){
    this.dialogService.open(ChangePasswordComponent, {
      width: '600px',
      
    });
  }
  onLanguageChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    if (target && target.value) {
      this.languageService.switchLang(target.value);
    }
  }
}
